export default __webpack_public_path__ + "static/media/roboto-v27-latin-500.ddd11dab.woff";